// extracted by mini-css-extract-plugin
export default {"image":"k6-z","loaded":"l6-z"};